module.exports = __webpack_public_path__ + "img/iconBuilding.6b881cd0.png";